export default __webpack_public_path__ + "static/media/back_arrow.4c2cc107.svg";